import React, {useEffect, useState} from 'react';
import HeaderTitle from './header';
import {Card, Input, Loader, Segment} from 'semantic-ui-react';
import {DailyQuotaTable} from './table';
import './styles.scss';
import {useSelector, useDispatch} from 'react-redux';
import {Actions} from '../../../common/actions';

const {
  fetchGetPriorizationDailyQuota,
  fetchUpdatePriorizationDailyQuota,
} = Actions;

const calculateSumDealers = (dealer) =>
  dealer.reduce((acc, obj) => acc + (isNaN(parseInt(obj.quota, 10)) ? 0 : parseInt(obj.quota, 10)), 0);

const DailyQuota = () => {
  const dispatch = useDispatch();
  const {
    dealersQuota,
    loading,
    totalQuota,
  } = useSelector((state) => state.dailyQuota);

  const [dealersQuotaCurr, setDealersQuotaCurr] = useState(dealersQuota);
  const [totalQuotaCurr, setTotalQuotaCurr] = useState(totalQuota);
  const [sumDealers, setSumDealers] = useState(calculateSumDealers(dealersQuota));

  useEffect(() => {
    setDealersQuotaCurr(dealersQuota);
    setTotalQuotaCurr(totalQuota);
  }, [totalQuota, dealersQuota]);
  useEffect(() => {
    setSumDealers(calculateSumDealers(dealersQuotaCurr));
  }, [dealersQuotaCurr]);
  useEffect(() => {
    dispatch(fetchGetPriorizationDailyQuota(dealersQuotaCurr));
  }, []);

  const updateMyData = (rowIndex, columnId, value) => {
    setDealersQuotaCurr((old) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          };
        }
        return row;
      })
    );
  };
  const handleSave = () => {
    const processedData = {'data': {
      'dealerQuota': dealersQuotaCurr.map((dealer) => ({
        ...dealer,
        'quota': dealer?.quota ? parseInt(dealer?.quota, 10) : 0,
      })),
      'dailyQuota': parseInt(totalQuotaCurr || 0, 10),
    }};
    dispatch(fetchUpdatePriorizationDailyQuota(processedData));
  };


  return (
    <>
      <HeaderTitle
        disabled={(sumDealers > totalQuotaCurr) || !totalQuotaCurr}
        handleSave={handleSave}
        messageSave={!totalQuotaCurr ? 'El cupo diario total no puede ser 0.' :
          'La suma del cupo de los dealers no debe ser mayor que el cupo total.'
        }
      />
      <Card fluid>
        <div className="priorization-total-quota-container">
          <span className='priorization-total-quota-title mr'>Cupo máximo diario:</span>
          <Input
            min='1'
            type='number'
            placeholder='0'
            value={totalQuotaCurr}
            loading={loading}
            onChange={(e) => {
              setTotalQuotaCurr(e.target.value || null);
            }}
          />
        </div>
      </Card>
      <Card fluid>
        {loading ? (
          <Segment className='priorization-loading-segment'>
            <Loader active />
          </Segment>
        ) : (
          <DailyQuotaTable dataTable={dealersQuotaCurr} updateMyData={updateMyData} />
        )}
      </Card>
    </>
  );
};

export default DailyQuota;
